import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function Privacy() {
  const navigate = useNavigate()
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', fontFamily: "'Inter', -apple-system, sans-serif" }}>
      <div style={{ backgroundColor: '#fff', borderBottom: '1px solid #f0f0f0' }}>
        <div style={{ maxWidth: 720, margin: '0 auto', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 16 }}>
          <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', color: '#2D7A3A', fontSize: 15, cursor: 'pointer', padding: 0 }}>‹ Späť</button>
          <span style={{ fontWeight: 700, color: '#1a1a1a' }}>Ochrana osobných údajov</span>
        </div>
      </div>
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px 20px', lineHeight: 1.8, color: '#444', fontSize: 15 }}>
        <p style={{ color: '#888', fontSize: 13, marginBottom: 32 }}>Posledná aktualizácia: 23. marca 2026</p>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', marginBottom: 12 }}>1. Prevádzkovateľ</h2>
        <p>Prevádzkovateľom služby Vigilant je fyzická/právnická osoba registrovaná na území Slovenskej republiky. Kontakt: podpora@vigilantapp.io</p>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '28px 0 12px' }}>2. Aké údaje zbierame</h2>
        <ul style={{ paddingLeft: 20 }}>
          <li>Meno a e-mailová adresa (pri registrácii)</li>
          <li>Telefónne číslo (voliteľné, pre SMS upozornenia)</li>
          <li>Údaje o pohybových udalostiach zo zariadení</li>
          <li>Technické údaje zariadení (stav batérie, čas posledného pripojenia)</li>
        </ul>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '28px 0 12px' }}>3. Účel spracovania</h2>
        <ul style={{ paddingLeft: 20 }}>
          <li>Poskytovanie služby monitorovania a zasielania upozornení</li>
          <li>Zabezpečenie prístupu k účtu</li>
          <li>Zasielanie týždenných správ a systémových notifikácií</li>
        </ul>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '28px 0 12px' }}>4. Doba uchovávania</h2>
        <p>Osobné údaje uchovávame po dobu trvania účtu. Po zmazaní účtu sú všetky údaje do 30 dní nevratne vymazané.</p>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '28px 0 12px' }}>5. Vaše práva (GDPR)</h2>
        <ul style={{ paddingLeft: 20 }}>
          <li>Právo na prístup k vašim údajom</li>
          <li>Právo na opravu nesprávnych údajov</li>
          <li>Právo na vymazanie ("právo byť zabudnutý")</li>
          <li>Právo na prenosnosť údajov</li>
          <li>Právo podať sťažnosť na Úrad pre ochranu osobných údajov SR</li>
        </ul>
        <p style={{ marginTop: 12 }}>Svoju žiadosť nám zašlite na: podpora@vigilantapp.io</p>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '28px 0 12px' }}>6. Súbory cookie</h2>
        <p>Vigilant používa iba technicky nevyhnutné cookies pre správnu funkciu prihlásenia. Nepoužívame sledovacie ani reklamné cookies.</p>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '28px 0 12px' }}>7. Tretie strany</h2>
        <p>Údaje môžu byť spracovávané prostredníctvom týchto subdodávateľov: Supabase (databáza, EU), Resend (e-mail), Render (hosting), Vercel (web hosting). Všetci spracúvajú údaje v súlade s GDPR.</p>
      </div>
    </div>
  )
}
